import { useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { ChevronDown } from "lucide-react";

export const FAQAccordion = ({ faqs, dark = false, defaultOpen = 0 }) => {
  const [open, setOpen] = useState(defaultOpen);
  const reduce = useReducedMotion();

  return (
    <div className={`divide-y rounded-xl border overflow-hidden ${dark ? "divide-white/10 border-white/10 bg-coal" : "divide-ink/10 border-ink/10 bg-paper"}`} data-testid="faq-accordion">
      {faqs.map((f, i) => {
        const isOpen = open === i;
        return (
          <div key={i}>
            <button
              type="button"
              aria-expanded={isOpen}
              aria-controls={`faq-panel-${i}`}
              data-testid={`faq-question-${i}`}
              onClick={() => setOpen(isOpen ? -1 : i)}
              className={`w-full flex items-center justify-between gap-4 text-left px-5 sm:px-7 py-5 transition-colors duration-300 ${
                dark ? "hover:bg-white/5" : "hover:bg-ivory/70"
              }`}
            >
              <span className={`font-display font-bold text-base sm:text-lg ${dark ? "text-white" : "text-ink"}`}>{f.q}</span>
              <motion.span animate={{ rotate: isOpen ? 180 : 0 }} transition={{ duration: 0.3 }} className="text-copper shrink-0" aria-hidden="true">
                <ChevronDown size={20} />
              </motion.span>
            </button>
            <AnimatePresence initial={false}>
              {isOpen && (
                <motion.div
                  id={`faq-panel-${i}`}
                  initial={reduce ? false : { height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                  className="overflow-hidden"
                >
                  <p className={`px-5 sm:px-7 pb-6 text-sm sm:text-base leading-relaxed ${dark ? "text-white/60" : "text-mute"}`} data-testid={`faq-answer-${i}`}>
                    {f.a}
                  </p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        );
      })}
    </div>
  );
};
